import { render, staticRenderFns } from "./CanvasMain.vue?vue&type=template&id=184074cc&scoped=true&"
import script from "./CanvasMain.vue?vue&type=script&lang=js&"
export * from "./CanvasMain.vue?vue&type=script&lang=js&"
import style0 from "./CanvasMain.vue?vue&type=style&index=0&id=184074cc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184074cc",
  null
  
)

export default component.exports